export const translations = {
  en: {
    // Language selector
    title: "Dice Roll Simulation",
    selectLanguage: "Please select your language",
    
    // Main simulation
    problemStatement: "When 4-sided die (1-4) and 6-sided die (1-6) are thrown, how is the distribution of the sums of the numbers on the top face?",
    
    // Controls
    start: "Start",
    stop: "Pause",
    reset: "Reset",
    speed: "Speed:",
    
    // Dice display
    dice4Title: "4-Sided Die",
    dice6Title: "6-Sided Die",
    sum: "Sum",
    //dice4Faces: "Faces: [1,2,3], [2,3,4], [3,4,1], [4,1,2]",
    //dice6Faces: "Faces: 1, 2, 3, 4, 5, 6",
    
    // Stats
    rollCount: "Roll Count:",
    maxRolls: "Max Rolls:",
    
    // Data tables
    dataTableTitle: "Sum and Frequency Distribution",
    total: "Sum",
    frequency: "Frequency",
    
    // Comments in code
    dice4FacesComment: "4-sided die faces (3 numbers on each face, top one is valid)",
    face1Comment: "Face 1: top is 1",
    face2Comment: "Face 2: top is 2", 
    face3Comment: "Face 3: top is 3",
    face4Comment: "Face 4: top is 4",
    initializeFrequencies: "Initialize frequencies",
    getTopNumber: "Get the top number",
    stopAtMaxRolls: "Stop when maximum roll count is reached",
    clearIntervalOnUnmount: "Clear interval when component unmounts"
  },
  
  tr: {
    // Language selector
    title: "Sayı Küpü Atma Simülasyonu",
    selectLanguage: "Lütfen dilinizi seçin",
    
    // Main simulation
    problemStatement: "4 yüzlü sayı küpü (1-4) ve 6 yüzlü sayı küpü (1-6) atıldığında üst yüze gelen sayıların toplamının dağılımı nasıl olur?",
    
    // Controls
    start: "Başlat",
    stop: "Durdur",
    reset: "Sıfırla",
    speed: "Hız:",
    
    // Dice display
    dice4Title: "4 Yüzlü Sayı Küpü",
    dice6Title: "6 Yüzlü Sayı Küpü",
    sum: "Toplam",
    //dice4Faces: "Yüzler: [1,2,3], [2,3,4], [3,4,1], [4,1,2]",
    //dice6Faces: "Yüzler: 1, 2, 3, 4, 5, 6",
    
    // Stats
    rollCount: "Atış Sayısı:",
    maxRolls: "Maksimum Atış:",
    
    // Data tables
    dataTableTitle: "Toplam Değerler ve Frekans Dağılımı",
    total: "Toplam",
    frequency: "Frekans",
    
    // Comments in code
    dice4FacesComment: "4 yüzlü zar yüzleri (her yüzde 3 sayı, üstteki geçerli)",
    face1Comment: "Yüz 1: üstteki 1",
    face2Comment: "Yüz 2: üstteki 2",
    face3Comment: "Yüz 3: üstteki 3", 
    face4Comment: "Yüz 4: üstteki 4",
    initializeFrequencies: "Frekansları başlat",
    getTopNumber: "Üstteki sayıyı al",
    stopAtMaxRolls: "Maksimum atış sayısına ulaşıldığında durdur",
    clearIntervalOnUnmount: "Component unmount olduğunda interval'i temizle"
  }
};
